///
/// EarthBrowser
///
/// Created by Matt Giger on 2/15/2025
/// Copyright (c) 2025 Geodata Labs
///

import { Button } from "@/components/ui/button"
import { useAppDispatch } from "@/redux/store"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { User } from "lucide-react"
import { setAuthOpen } from "@/redux/dialogSlice"

export function SignInHeaderButton() {
	const dispatch = useAppDispatch()

	function handleClick() {
		dispatch(setAuthOpen(true))
	}

	return (
		<Button variant="outline"
			onClick={handleClick}>

			<Avatar className="h-4 w-4 rounded-lg">
				<AvatarImage alt="EarthBrowser"/>
				<AvatarFallback className="rounded-lg">
					<User />
				</AvatarFallback>
			</Avatar>
			<div className="grid flex-1 text-left text-sm leading-tight">
				<span className="truncate font-semibold">
						Sign In
				</span>
			</div>
		</Button>
	)
}
